import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class IframeResizeService {
  constructor() {
    if (window.self == window.top) return;
    if (document.referrer) {
      try {
        const host = new URL(document.referrer).hostname?.replace(/^www\./i, '');
        if (environment.allowedParentHosts.includes(host)) {
          this.sendHeightMessageOnResize();
        } else {
          console.warn('Parent URL not trusted, skipping iframe resize messaging.');
        }
      } catch {
        console.warn('Invalid referrer, skipping iframe resize messaging.');
      }
    }
  }

  private sendHeightMessageOnResize() {
    const observer = new ResizeObserver(() => {
      const pass_data = {
        newHeight: document.body.scrollHeight,
        contentheight: document.body.scrollHeight,
      };
      window.parent.postMessage(JSON.stringify(pass_data), environment.parentOrigin);
    });
    observer.observe(document.body);
  }
}
